import React from "react";
import Navbar from "../components/Navbar";

const BaseLayout = (props) => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="pt-10">{props.children}</div>
    </div>
  );
};

export default BaseLayout;
